import React, { useState } from "react";
import MouseFooter from "../components/MouseFooter";
import "../styles/privacy-terms.css";
import { Link, useNavigate } from "react-router-dom";

export default function Terms() {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const goToSection = (e, id) => {
    e.preventDefault();
    navigate("/"); // always go home first
    setTimeout(() => {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    }, 100);
    setMenuOpen(false);
  };

  return (
    <>
      {/* Navbar */}
      <header className="navbar">
      <div className="logo">
          <Link
            to="/"
            onClick={() => {
              window.scrollTo({ top: 0, behavior: "smooth" });
            }}
          >
            <img src="/ego.png" alt="Ego Blockchain Logo" className="logo-img" />
          </Link>
        </div>

        {/* Hamburger button */}
        <button
          className={`hamburger ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Nav links */}
        <nav className={`nav-links ${menuOpen ? "open" : ""}`}>
          <Link to="/download" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
            Download Ego Desktop
          </Link>
          <Link to="/blog" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
            Blog
          </Link>
          <Link to="/docs" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
            Docs
          </Link>
          <Link to="/egoscan" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
            EgoScan
          </Link>
          <Link to="/claim" onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}>
            Claim EGOC
          </Link>
        </nav>
      </header>

                  {/* Overlay (click to close) */}
                  {menuOpen && (
        <div className="menu-overlay" onClick={() => setMenuOpen(false)} />
      )}

      {/* Terms Content */}
      <div className="terms-container">
        <h1>Terms and Conditions of Ego Blockchain</h1>
        <p><strong>Effective Date:</strong> November 12, 2024<br /><strong>Last Updated:</strong> October 14, 2026</p>

        <h2>1. Definitions</h2>
        <p>
          “Ego Blockchain,” “we,” “us,” “our” refers to <strong>Ego Blockchain Corp.</strong>, a corporation incorporated in
          Alberta, Canada (Corporate Access Number 2028603237), with its head
          office at 314 Coventry Cir NE, Calgary, Alberta T3K 4X8, Canada.
          “User,” “you” refers to anyone using our services.
        </p>

        <h2>2. Use of Services</h2>
        <p>Must be over 18, use services lawfully, and follow all regulations.</p>

        <h2>2a. Background Operation of Ego Desktop</h2>
        <p>
          Ego Desktop is node software intended to run continuously. The first
          time you open it, it asks whether it should start automatically when
          you sign in to your computer; you can change this at any time in
          Settings under &quot;Start at login&quot;. Closing the application
          window does not terminate it; the node continues operating in the
          background, consuming disk space, network bandwidth and processing
          capacity in order to participate in the network and accrue
          rewards.
        </p>
        <p>
          You are responsible for any costs arising from this operation,
          including metered or capped internet connections, electricity, and any
          limits imposed by your network provider. You may stop the application
          at any time by selecting Quit from its system tray menu, adjust its
          resource usage in the application&apos;s settings, or remove it from
          your operating system&apos;s start-up items. The application never
          turns start-up on without asking you.
        </p>

        <h2>3. Account Registration</h2>
        <p>Maintain confidentiality of account; you’re responsible for activity.</p>

        <h2>4. Intellectual Property Rights</h2>
        <p>The Ego software, the names Ego, Ego Blockchain and EGOC, and the Ego logos belong to Ego Blockchain Corp. unless stated otherwise. Open-source components remain under their own licences.</p>

        <h2>5. Acceptable Use</h2>
        <p>No illegal, harmful, or abusive activities allowed.</p>

        <h2>6. Limitation of Liability</h2>
        <p>No liability for damages. Services are “as is” and “as available.”</p>

        <h2>7. No Investment Advice</h2>
        <p>Content is informational only; not legal or financial advice.</p>

        <h2>8. Links to Third-Parties</h2>
        <p>We aren’t responsible for third-party websites.</p>

        <h2>8a. Third-Party Swap, Payment and Ramp Services</h2>
        <p>
          Certain features are provided by independent third parties. Where that
          is the case, your transaction is with that provider and not with Ego
          Blockchain. We are not a party to it, we do not take custody of your
          funds at any point, and we cannot reverse, refund, or cancel it.
        </p>
        <ul>
          <li>
            <strong>Swaps.</strong> Exchanges between external cryptocurrencies
            are executed by ChangeNow. Rates, fees, minimum and maximum amounts,
            processing times, and any identity verification are set by ChangeNow
            under its own terms. Ego Blockchain displays quotes it returns and
            passes on your destination address; we do not set the rate, hold the
            funds, or guarantee completion. Blockchain transactions are
            irreversible — an incorrect address or network cannot be undone.
          </li>
          <li>
            <strong>Pre-sale card payments.</strong> Card payments are processed
            by Stripe under its terms. We do not receive or store card details.
          </li>
          <li>
            <strong>Buying and selling crypto with fiat (when enabled).</strong>{" "}
            Where offered, these are provided by a licensed third-party payment
            provider. That provider is solely responsible for the payment,
            identity verification, and delivery of the assets. Eligibility and
            availability depend on your jurisdiction and are determined by the
            provider, not by us.
          </li>
        </ul>
        <p>
          Support for a third-party transaction must be sought from that
          provider. We will help you identify the correct provider and reference
          where we can, but we have no ability to intervene in, alter, or
          reverse it.
        </p>
        <p>
          <strong>Ego Blockchain is non-custodial.</strong> You control your own
          private keys. We cannot access, freeze, move, or recover your funds,
          and we cannot restore a lost recovery phrase.
        </p>

        <h2>9. Modifications</h2>
        <p>We may modify services anytime.</p>

        <h2>10. Termination</h2>
        <p>Access may be terminated if terms are breached.</p>

        <h2>11. Governing Law</h2>
        <p>These terms are governed by the laws of the Province of Alberta and the federal laws of Canada that apply there. You agree to the jurisdiction of the courts of Alberta, unless the law of your place of residence gives you a right to bring a claim there.</p>

        <h2>12. Changes</h2>
        <p>We may revise terms anytime; continued use means acceptance.</p>

        <h2>13. Indemnification</h2>
        <p>You agree to indemnify Ego Blockchain against claims from violations.</p>

        <h2>14. Entire Agreement</h2>
        <p>These terms + Privacy Policy = full agreement.</p>

        <h2>15. Ego Desktop and Node Operation</h2>
        <p>
          Ego Desktop runs a peer-to-peer node on your device. By installing and
          using it, you acknowledge and agree that:
        </p>
        <ul>
          <li>
            The application <strong>automatically allocates and uses
            approximately 10&nbsp;GB of your device&apos;s storage</strong> to
            hold encrypted network data and file replicas. You are responsible
            for ensuring sufficient free disk space; you may adjust or release
            this allocation in the app&apos;s settings.
          </li>
          <li>
            Your node contributes <strong>bandwidth, storage, and (where you
            enable it) CPU/GPU compute</strong> to the network, and participates
            in <strong>Proof of Coverage</strong> using approximate location and
            network connectivity data to verify coverage.
          </li>
          <li>
            Your node also <strong>serves Ego Wallet phones</strong>: it relays
            their requests to the network over an encrypted connection and, where
            your router allows it, opens a port on your router for this through
            UPnP. Phones sign everything themselves, so your node never sees
            their keys. Each phone is rate limited.
          </li>
          <li>
            Rewards in EGOC for storage, coverage, consensus, and retrieval are
            variable, are not guaranteed, and depend on network conditions,
            uptime, and protocol rules, which may change.
          </li>
          <li>
            You are responsible for the security of your device, recovery phrase,
            and keys. Lost keys cannot be recovered, and on-chain transactions
            cannot be reversed.
          </li>
          <li>
            You will run a node only on devices and connections you are
            authorized to use, and in compliance with applicable laws, your
            internet service provider&apos;s terms, and any local regulations
            regarding bandwidth, energy use, and data.
          </li>
        </ul>

        <h2>16. Contact</h2>
        <p>
          Ego Blockchain Corp.<br />
          314 Coventry Cir NE, Calgary, Alberta T3K 4X8, Canada<br />
          Email:{" "}
          <a
            href="mailto:support@egoblockchain.com"
            style={{ color: "yellow", cursor: "none", textDecoration: "none" }}
          >
            support@egoblockchain.com
          </a>
        </p>

      </div>

      <MouseFooter />
    </>
  );
}
